import { Component, OnInit } from '@angular/core';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { Note } from '../../calvin-emr-shared/models/note.model';
import { DividerModule } from 'primeng/divider';
import { ButtonDirective } from 'primeng/button';

@Component({
    selector: 'app-html-dialog',
    templateUrl: './html-dialog.component.html',
    styleUrls: ['./html-dialog.component.scss'],
    standalone: true,
    imports: [DividerModule, ButtonDirective],
})
export class HtmlDialogComponent implements OnInit {
  /**
   * The date and time the note was created.
   */
  datetime: string;

  /**
   * The string containing the HTML content to render in the dialog.
   */
  htmlString: string;

  /**
   * The signature of the provider that signed the note.
   */
  signature: string;

  constructor(public ref: DynamicDialogRef, public config: DynamicDialogConfig) {
    const note = config.data as Note;
    this.datetime = note.datetimeString;
    this.htmlString = note.content;
    this.signature = note.signature;
  }

  ngOnInit(): void {}

  closeDialog() {
    this.ref.close();
  }
}
